import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p425462213840572416',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
